import moment from "moment";
import {hasRole, ROLES} from "utils/userStorage";
import {DATE_FORMATS} from "./Date";

export const MINIMAL_EDIT_OFFSET = 1;

/**
 * Check if a treatment is too soon to be cancelled.
 * an Admin can always cancel a treatment.
 */
export function isTooSoon(treatment, checkRole = true) {
  if (checkRole && hasRole([ROLES.Admin, ROLES.CS, ROLES.KPT])) {
    return false;
  }
  if (!treatment.planned_date_time_from) {
    return false;
  }

  const parsed = moment(treatment.planned_date_time_from, DATE_FORMATS.BUMBAL);
  const threshold = moment().add(MINIMAL_EDIT_OFFSET, "d");
  return parsed.isSameOrBefore(threshold, "d");
}

export function isAdminOnly(treatment) {
  return !!isTooSoon(treatment, false);
}
